






import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import CanBeSizedMixin from '../../mixins/CanBeSizedMixin.vue';
import ScrollableMixin from '../../mixins/ScrollableMixin.vue';
import { ShopDetailsModel, ShopInfoModel } from '../../models/ShopDetails';

@Component({})
export default class CameraDetails extends mixins(CanBeSizedMixin) {
  /* tslint:disable */
  @Prop() private offer!: string;
  /* tslint:enable */
}
